import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { ContentCard } from '@nike/nike-design-system-components';
import styled from '@emotion/styled';
import { useStadium } from 'stadium/StadiumHooks';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var getCamelCase = function getCamelCase(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
var Imagetext = function Imagetext(props) {
  var mediaHost = props.mediaHost,
    placement = props.placement,
    xfPath = props.xfPath,
    defaultImageWidth = props.defaultImageWidth,
    defaultImageLength = props.defaultImageLength,
    _props$root = props.root,
    _props$root$image = _props$root.image,
    _props$root$image$fil = _props$root$image.fileReference,
    image = _props$root$image$fil === void 0 ? '' : _props$root$image$fil,
    _props$root$image$ima = _props$root$image.imageWidth,
    imageWidth = _props$root$image$ima === void 0 ? defaultImageWidth : _props$root$image$ima,
    _props$root$image$ima2 = _props$root$image.imageLength,
    imageLength = _props$root$image$ima2 === void 0 ? defaultImageLength : _props$root$image$ima2,
    _props$root$descripti = _props$root.description,
    description = _props$root$descripti === void 0 ? ' ' : _props$root$descripti,
    _props$root$eyebrowTe = _props$root.eyebrowText,
    eyebrowText = _props$root$eyebrowTe === void 0 ? '' : _props$root$eyebrowTe,
    _props$root$headLineO = _props$root.headLineOne,
    headLineOne = _props$root$headLineO === void 0 ? '' : _props$root$headLineO,
    _props$root$headLineT = _props$root.headLineTwo,
    headLineTwo = _props$root$headLineT === void 0 ? '' : _props$root$headLineT,
    _props$root$leftButto = _props$root.leftButtonText,
    leftButtonText = _props$root$leftButto === void 0 ? '' : _props$root$leftButto,
    _props$root$leftButto2 = _props$root.leftButtonLink,
    leftButtonLink = _props$root$leftButto2 === void 0 ? '' : _props$root$leftButto2,
    _props$root$leftButto3 = _props$root.leftButtonTabCheck,
    leftButtonTabCheck = _props$root$leftButto3 === void 0 ? 'false' : _props$root$leftButto3,
    _props$root$rightButt = _props$root.rightButtonText,
    rightButtonText = _props$root$rightButt === void 0 ? '' : _props$root$rightButt,
    _props$root$rightButt2 = _props$root.rightButtonLink,
    rightButtonLink = _props$root$rightButt2 === void 0 ? '' : _props$root$rightButt2,
    _props$root$rightButt3 = _props$root.rightButtonTabCheck,
    rightButtonTabCheck = _props$root$rightButt3 === void 0 ? 'false' : _props$root$rightButt3,
    _props$root$theme = _props$root.theme,
    theme = _props$root$theme === void 0 ? 'light' : _props$root$theme,
    _props$root$verticalA = _props$root.verticalAlignment,
    verticalAlignment = _props$root$verticalA === void 0 ? 'top' : _props$root$verticalA,
    _props$root$alignment = _props$root.alignment,
    alignment = _props$root$alignment === void 0 ? 'left' : _props$root$alignment;
  var _useStadium = useStadium(),
    sendInteractionEvent = _useStadium.analyticsHooks.sendInteractionEvent;
  var StyledContentCard = styled(ContentCard)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    max-width: 100%;\n    .nds-stack {\n      text-align: ", ";\n    }\n    /* Display newlines for description text */\n    p { white-space: pre-wrap }\n  "])), verticalAlignment === 'middle' ? alignment : {});
  return /*#__PURE__*/_jsx(StyledContentCard, {
    body: description,
    eyebrow: eyebrowText
    // @ts-expect-error
    ,
    headline: headLineTwo ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [headLineOne, /*#__PURE__*/_jsx("br", {}), headLineTwo]
    }) : headLineOne
    // @ts-expect-error
    ,
    imageAspectRatio: "".concat(imageWidth, "/").concat(imageLength),
    imageCompProps: {
      borderRadius: 'none'
    }
    // @ts-expect-error
    ,
    textLocation: verticalAlignment === 'middle' ? 'Center' : "".concat(getCamelCase(verticalAlignment), " ").concat(getCamelCase(alignment)),
    primaryCTA: {
      label: leftButtonText,
      href: leftButtonLink,
      target: leftButtonTabCheck === 'true' ? '_blank' : '_self'
    },
    secondaryCTA: {
      label: rightButtonText,
      href: rightButtonLink,
      target: rightButtonTabCheck === 'true' ? '_blank' : '_self'
    },
    background: theme === 'light' ? 'dark' : 'light',
    image: {
      src: image.includes('http') ? image : mediaHost + image,
      alt: 'Nike'
    },
    primaryCTAProps: {
      onClick: function onClick() {
        sendInteractionEvent("homepage:".concat(placement, ":").concat(xfPath, ":").concat(leftButtonText, ":").concat(leftButtonLink));
        return false;
      }
    },
    secondaryCTAProps: {
      onClick: function onClick() {
        sendInteractionEvent("homepage:".concat(placement, ":").concat(xfPath, ":").concat(rightButtonText, ":").concat(rightButtonLink));
        return false;
      }
    }
  });
};
export default Imagetext;